// ------------------------------------
// Constants
// ------------------------------------
export const SELECT_LOCATION = 'SELECT_LOCATION'

// ------------------------------------
// Actions
// ------------------------------------
export function selectLocation (value = true) {
  return {
    type    : SELECT_LOCATION,
    payload : value
  }
}

export const actions = { selectLocation }

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [SELECT_LOCATION] : (state, action) => action.payload
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = null
export default function officeLocationReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/store/officeLocation.js